/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  Category,
  CategoryHierarchyNode,
  GetHierarchyTreeForCategoriesServerParams,
  GetLinkedProductsByIdServerParams,
  GetPopularBrandsServerParams,
  GetProductByProductCodeAndColorWithFallbackServerParams,
  GetProductByProductCodeParams,
  GetProductByProductCodeServerParams,
  GetProductByProductCodeWithFallbackServerParams,
  GetProductFeaturesComparisonParams,
  GetProductFeaturesComparisonServerParams,
  GetProductManualByIdServerParams,
  GetProductPlacementCopyByIdServerParams,
  GetProductTechnicalCategoriesByIdServerParams,
  GetProductTechnicalFeaturesFlattenedServerParams,
  GetProductVideoByIdServerParams,
  GetVoucherMinMaxAmountServerParams,
  ListerProductDTO,
  PdpProductAvailabilityDTO,
  PopularBrandsResource,
  PriceRange,
  ProductColourLinkFlatDTO,
  ProductManual,
  ProductPlacementCopyResource,
  ProductVariantDTO,
  ProductVideo,
  ProductWithComparisonFeatures,
  ProductWithFlattenedFeatures,
  StoreSourceExclusionSkuDTO,
  TechnicalCategory,
} from '@as-react/common-types/product-service';
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import type { ErrorType } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary endpoint to retrieve a map of all hierarchical categories for a category group. List in order of tree structure (parent first, level1child, level 2 child etc)
 */
export const getHierarchyTreeForCategoriesServer = (
  market: string,
  mainWebShopId: number,
  getHierarchyTreeForCategoriesServerBody: Array<number>,
  params?: GetHierarchyTreeForCategoriesServerParams,
  operationName = 'getHierarchyTreeForCategories',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<CategoryHierarchyNode>(
    {
      url: `/cache/category/${market}/hierarchy/${mainWebShopId}/tree`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: getHierarchyTreeForCategoriesServerBody,
      params,
      signal,
    },
    { operationName: 'getHierarchyTreeForCategories', ...options }
  );
};

export const getGetHierarchyTreeForCategoriesServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getHierarchyTreeForCategoriesServer>>,
    TError,
    {
      market: string;
      mainWebShopId: number;
      data: Array<number>;
      params?: GetHierarchyTreeForCategoriesServerParams;
      operationName?: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getHierarchyTreeForCategoriesServer>>,
  TError,
  {
    market: string;
    mainWebShopId: number;
    data: Array<number>;
    params?: GetHierarchyTreeForCategoriesServerParams;
    operationName?: string;
  },
  TContext
> => {
  const mutationKey = ['getHierarchyTreeForCategoriesServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getHierarchyTreeForCategoriesServer>>,
    {
      market: string;
      mainWebShopId: number;
      data: Array<number>;
      params?: GetHierarchyTreeForCategoriesServerParams;
      operationName?: string;
    }
  > = props => {
    const { market, mainWebShopId, data, params, operationName } = props ?? {};

    return getHierarchyTreeForCategoriesServer(market, mainWebShopId, data, params, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetHierarchyTreeForCategoriesServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof getHierarchyTreeForCategoriesServer>>
>;
export type GetHierarchyTreeForCategoriesServerMutationBody = Array<number>;
export type GetHierarchyTreeForCategoriesServerMutationError = ErrorType<unknown>;

/**
 * @summary endpoint to retrieve a map of all hierarchical categories for a category group. List in order of tree structure (parent first, level1child, level 2 child etc)
 */
export const useGetHierarchyTreeForCategoriesServer = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getHierarchyTreeForCategoriesServer>>,
      TError,
      {
        market: string;
        mainWebShopId: number;
        data: Array<number>;
        params?: GetHierarchyTreeForCategoriesServerParams;
        operationName?: string;
      },
      TContext
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getHierarchyTreeForCategoriesServer>>,
  TError,
  {
    market: string;
    mainWebShopId: number;
    data: Array<number>;
    params?: GetHierarchyTreeForCategoriesServerParams;
    operationName?: string;
  },
  TContext
> => {
  const mutationOptions = getGetHierarchyTreeForCategoriesServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Find a product with fallback if not available
 */
export const getProductByProductCodeWithFallbackServer = (
  mainWebshop: string,
  productCode: string,
  params: GetProductByProductCodeWithFallbackServerParams,
  operationName = 'getProductByProductCodeWithFallback',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ListerProductDTO | ListerProductDTO>(
    {
      url: `/public/enrichedproduct/productcode/fallback/${mainWebshop}/${productCode}`,
      method: 'GET',
      params,
      signal,
    },
    { operationName: 'getProductByProductCodeWithFallback', ...options }
  );
};

export const useGetProductByProductCodeWithFallbackServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  params: GetProductByProductCodeWithFallbackServerParams,
  operationName = 'getProductByProductCodeWithFallback',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebshop, productCode, params, operationName },
    { url: `/public/enrichedproduct/productcode/fallback/${mainWebshop}/${productCode}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>> = ({ signal }) =>
    getProductByProductCodeWithFallbackServer(mainWebshop, productCode, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebshop && productCode), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductByProductCodeWithFallbackServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>
>;
export type GetProductByProductCodeWithFallbackServerQueryError = ErrorType<unknown>;

export function useGetProductByProductCodeWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  params: GetProductByProductCodeWithFallbackServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
          TError,
          Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCodeWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  params: GetProductByProductCodeWithFallbackServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
          TError,
          Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCodeWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  params: GetProductByProductCodeWithFallbackServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find a product with fallback if not available
 */

export function useGetProductByProductCodeWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  params: GetProductByProductCodeWithFallbackServerParams,
  operationName = 'getProductByProductCodeWithFallback',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeWithFallbackServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductByProductCodeWithFallbackServerQueryOptions(
    mainWebshop,
    productCode,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find a product and color with fallback if not available
 */
export const getProductByProductCodeAndColorWithFallbackServer = (
  mainWebshop: string,
  productCode: string,
  colorId: number,
  params: GetProductByProductCodeAndColorWithFallbackServerParams,
  operationName = 'getProductByProductCodeAndColorWithFallback',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ListerProductDTO | ListerProductDTO>(
    {
      url: `/public/enrichedproduct/productcode/fallback/${mainWebshop}/${productCode}/${colorId}`,
      method: 'GET',
      params,
      signal,
    },
    { operationName: 'getProductByProductCodeAndColorWithFallback', ...options }
  );
};

export const useGetProductByProductCodeAndColorWithFallbackServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  colorId: number,
  params: GetProductByProductCodeAndColorWithFallbackServerParams,
  operationName = 'getProductByProductCodeAndColorWithFallback',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebshop, productCode, colorId, params, operationName },
    { url: `/public/enrichedproduct/productcode/fallback/${mainWebshop}/${productCode}/${colorId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>> = ({
    signal,
  }) =>
    getProductByProductCodeAndColorWithFallbackServer(
      mainWebshop,
      productCode,
      colorId,
      params,
      operationName,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, enabled: !!(mainWebshop && productCode && colorId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductByProductCodeAndColorWithFallbackServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>
>;
export type GetProductByProductCodeAndColorWithFallbackServerQueryError = ErrorType<unknown>;

export function useGetProductByProductCodeAndColorWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  colorId: number,
  params: GetProductByProductCodeAndColorWithFallbackServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
          TError,
          Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCodeAndColorWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  colorId: number,
  params: GetProductByProductCodeAndColorWithFallbackServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
          TError,
          Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCodeAndColorWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  colorId: number,
  params: GetProductByProductCodeAndColorWithFallbackServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find a product and color with fallback if not available
 */

export function useGetProductByProductCodeAndColorWithFallbackServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebshop: string,
  productCode: string,
  colorId: number,
  params: GetProductByProductCodeAndColorWithFallbackServerParams,
  operationName = 'getProductByProductCodeAndColorWithFallback',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeAndColorWithFallbackServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductByProductCodeAndColorWithFallbackServerQueryOptions(
    mainWebshop,
    productCode,
    colorId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetProductFeaturesComparisonHook = () => {
  const getProductFeaturesComparison = useQueryFetch<ProductWithComparisonFeatures>();

  return useCallback(
    (
      market: string,
      mainWebShopId: number,
      productId: number,
      params?: GetProductFeaturesComparisonParams,
      operationName = 'getProductFeaturesComparison',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getProductFeaturesComparison(
        {
          url: `/api/aem/product/features/comparison/${market}/${mainWebShopId}/${productId}`,
          method: 'GET',
          params,
          signal,
        },
        { operationName: 'getProductFeaturesComparison', ...options }
      );
    },
    [getProductFeaturesComparison]
  );
};

export const useGetProductFeaturesComparisonQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonParams,
  operationName = 'getProductFeaturesComparison',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, productId, params, operationName },
    { url: `/api/aem/product/features/comparison/${market}/${mainWebShopId}/${productId}`, queryOptions }
  );

  const getProductFeaturesComparison = useGetProductFeaturesComparisonHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>> = ({
    signal,
  }) => getProductFeaturesComparison(market, mainWebShopId, productId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(market && mainWebShopId && productId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductFeaturesComparisonQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>
>;
export type GetProductFeaturesComparisonQueryError = ErrorType<unknown>;

export function useGetProductFeaturesComparison<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params: undefined | GetProductFeaturesComparisonParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductFeaturesComparison<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductFeaturesComparison<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductFeaturesComparison<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonParams,
  operationName = 'getProductFeaturesComparison',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductFeaturesComparisonHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductFeaturesComparisonQueryOptions(
    market,
    mainWebShopId,
    productId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductFeaturesComparisonServer = (
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonServerParams,
  operationName = 'getProductFeaturesComparison',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ProductWithComparisonFeatures>(
    {
      url: `/public/cache/product/features/comparison/${market}/${mainWebShopId}/${productId}`,
      method: 'GET',
      params,
      signal,
    },
    { operationName: 'getProductFeaturesComparison', ...options }
  );
};

export const useGetProductFeaturesComparisonServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonServerParams,
  operationName = 'getProductFeaturesComparison',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, productId, params, operationName },
    { url: `/public/cache/product/features/comparison/${market}/${mainWebShopId}/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>> = ({ signal }) =>
    getProductFeaturesComparisonServer(market, mainWebShopId, productId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(market && mainWebShopId && productId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductFeaturesComparisonServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>
>;
export type GetProductFeaturesComparisonServerQueryError = ErrorType<unknown>;

export function useGetProductFeaturesComparisonServer<
  TData = Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params: undefined | GetProductFeaturesComparisonServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
          TError,
          Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductFeaturesComparisonServer<
  TData = Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
          TError,
          Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductFeaturesComparisonServer<
  TData = Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductFeaturesComparisonServer<
  TData = Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductFeaturesComparisonServerParams,
  operationName = 'getProductFeaturesComparison',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductFeaturesComparisonServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductFeaturesComparisonServerQueryOptions(
    market,
    mainWebShopId,
    productId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductVariantsByProductCodeServer = (
  productCode: string,
  market: string,
  language: string,
  shop: string,
  operationName = 'getProductVariantsByProductCode',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<ProductVariantDTO>>(
    { url: `/productvariant/${productCode}/${market}/${language}/${shop}`, method: 'GET', signal },
    { operationName: 'getProductVariantsByProductCode', ...options }
  );
};

export const useGetProductVariantsByProductCodeServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  productCode: string,
  market: string,
  language: string,
  shop: string,
  operationName = 'getProductVariantsByProductCode',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productCode, market, language, shop, operationName },
    { url: `/productvariant/${productCode}/${market}/${language}/${shop}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>> = ({ signal }) =>
    getProductVariantsByProductCodeServer(productCode, market, language, shop, operationName, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(productCode && market && language && shop),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetProductVariantsByProductCodeServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>
>;
export type GetProductVariantsByProductCodeServerQueryError = ErrorType<unknown>;

export function useGetProductVariantsByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  productCode: string,
  market: string,
  language: string,
  shop: string,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>,
          TError,
          Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductVariantsByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  productCode: string,
  market: string,
  language: string,
  shop: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>,
          TError,
          Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductVariantsByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  productCode: string,
  market: string,
  language: string,
  shop: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductVariantsByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  productCode: string,
  market: string,
  language: string,
  shop: string,
  operationName = 'getProductVariantsByProductCode',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantsByProductCodeServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductVariantsByProductCodeServerQueryOptions(
    productCode,
    market,
    language,
    shop,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductExclusionsServer = (
  market: string,
  mainWebShopId: number,
  fictiveWebShopId: number,
  productId: number,
  operationName = 'getProductExclusions',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<StoreSourceExclusionSkuDTO>>(
    { url: `/product/exclusions/${market}/${mainWebShopId}/${fictiveWebShopId}/${productId}`, method: 'GET', signal },
    { operationName: 'getProductExclusions', ...options }
  );
};

export const useGetProductExclusionsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductExclusionsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  fictiveWebShopId: number,
  productId: number,
  operationName = 'getProductExclusions',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductExclusionsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, fictiveWebShopId, productId, operationName },
    { url: `/product/exclusions/${market}/${mainWebShopId}/${fictiveWebShopId}/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductExclusionsServer>>> = ({ signal }) =>
    getProductExclusionsServer(
      market,
      mainWebShopId,
      fictiveWebShopId,
      productId,
      operationName,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(market && mainWebShopId && fictiveWebShopId && productId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProductExclusionsServer>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetProductExclusionsServerQueryResult = NonNullable<Awaited<ReturnType<typeof getProductExclusionsServer>>>;
export type GetProductExclusionsServerQueryError = ErrorType<unknown>;

export function useGetProductExclusionsServer<
  TData = Awaited<ReturnType<typeof getProductExclusionsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  fictiveWebShopId: number,
  productId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductExclusionsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductExclusionsServer>>,
          TError,
          Awaited<ReturnType<typeof getProductExclusionsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductExclusionsServer<
  TData = Awaited<ReturnType<typeof getProductExclusionsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  fictiveWebShopId: number,
  productId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductExclusionsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductExclusionsServer>>,
          TError,
          Awaited<ReturnType<typeof getProductExclusionsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductExclusionsServer<
  TData = Awaited<ReturnType<typeof getProductExclusionsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  fictiveWebShopId: number,
  productId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductExclusionsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductExclusionsServer<
  TData = Awaited<ReturnType<typeof getProductExclusionsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  fictiveWebShopId: number,
  productId: number,
  operationName = 'getProductExclusions',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductExclusionsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductExclusionsServerQueryOptions(
    market,
    mainWebShopId,
    fictiveWebShopId,
    productId,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPopularBrandsServer = (
  params: GetPopularBrandsServerParams,
  operationName = 'getPopularBrands',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PopularBrandsResource>(
    { url: `/popularbrand`, method: 'GET', params, signal },
    { operationName: 'getPopularBrands', ...options }
  );
};

export const useGetPopularBrandsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getPopularBrandsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetPopularBrandsServerParams,
  operationName = 'getPopularBrands',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPopularBrandsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/popularbrand`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPopularBrandsServer>>> = ({ signal }) =>
    getPopularBrandsServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPopularBrandsServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPopularBrandsServerQueryResult = NonNullable<Awaited<ReturnType<typeof getPopularBrandsServer>>>;
export type GetPopularBrandsServerQueryError = ErrorType<unknown>;

export function useGetPopularBrandsServer<
  TData = Awaited<ReturnType<typeof getPopularBrandsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetPopularBrandsServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPopularBrandsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPopularBrandsServer>>,
          TError,
          Awaited<ReturnType<typeof getPopularBrandsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPopularBrandsServer<
  TData = Awaited<ReturnType<typeof getPopularBrandsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetPopularBrandsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPopularBrandsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPopularBrandsServer>>,
          TError,
          Awaited<ReturnType<typeof getPopularBrandsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPopularBrandsServer<
  TData = Awaited<ReturnType<typeof getPopularBrandsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetPopularBrandsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPopularBrandsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPopularBrandsServer<
  TData = Awaited<ReturnType<typeof getPopularBrandsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetPopularBrandsServerParams,
  operationName = 'getPopularBrands',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPopularBrandsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetPopularBrandsServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetProductByProductCodeHook = () => {
  const getProductByProductCode = useQueryFetch<ListerProductDTO>();

  return useCallback(
    (
      params: GetProductByProductCodeParams,
      operationName = 'getProductByProductCode',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getProductByProductCode(
        { url: `/api/aem/product/productcode`, method: 'GET', params, signal },
        { operationName: 'getProductByProductCode', ...options }
      );
    },
    [getProductByProductCode]
  );
};

export const useGetProductByProductCodeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeParams,
  operationName = 'getProductByProductCode',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/aem/product/productcode`, queryOptions });

  const getProductByProductCode = useGetProductByProductCodeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>> = ({ signal }) =>
    getProductByProductCode(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductByProductCodeQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>
>;
export type GetProductByProductCodeQueryError = ErrorType<unknown>;

export function useGetProductByProductCode<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCode<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCode<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductByProductCode<
  TData = Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeParams,
  operationName = 'getProductByProductCode',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProductByProductCodeHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductByProductCodeQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductByProductCodeServer = (
  params: GetProductByProductCodeServerParams,
  operationName = 'getProductByProductCode',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ListerProductDTO>(
    { url: `/enrichedproduct/productcode`, method: 'GET', params, signal },
    { operationName: 'getProductByProductCode', ...options }
  );
};

export const useGetProductByProductCodeServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeServerParams,
  operationName = 'getProductByProductCode',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/enrichedproduct/productcode`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductByProductCodeServer>>> = ({ signal }) =>
    getProductByProductCodeServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductByProductCodeServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductByProductCodeServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductByProductCodeServer>>
>;
export type GetProductByProductCodeServerQueryError = ErrorType<unknown>;

export function useGetProductByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByProductCodeServer>>,
          TError,
          Awaited<ReturnType<typeof getProductByProductCodeServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByProductCodeServer>>,
          TError,
          Awaited<ReturnType<typeof getProductByProductCodeServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductByProductCodeServer<
  TData = Awaited<ReturnType<typeof getProductByProductCodeServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetProductByProductCodeServerParams,
  operationName = 'getProductByProductCode',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByProductCodeServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductByProductCodeServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductVideoByIdServer = (
  productId: number,
  params: GetProductVideoByIdServerParams,
  operationName = 'getProductVideoById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<ProductVideo>>(
    { url: `/cache/productvideo/${productId}`, method: 'GET', params, signal },
    { operationName: 'getProductVideoById', ...options }
  );
};

export const useGetProductVideoByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductVideoByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductVideoByIdServerParams,
  operationName = 'getProductVideoById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVideoByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productId, params, operationName },
    { url: `/cache/productvideo/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductVideoByIdServer>>> = ({ signal }) =>
    getProductVideoByIdServer(productId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductVideoByIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductVideoByIdServerQueryResult = NonNullable<Awaited<ReturnType<typeof getProductVideoByIdServer>>>;
export type GetProductVideoByIdServerQueryError = ErrorType<unknown>;

export function useGetProductVideoByIdServer<
  TData = Awaited<ReturnType<typeof getProductVideoByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductVideoByIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVideoByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVideoByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductVideoByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductVideoByIdServer<
  TData = Awaited<ReturnType<typeof getProductVideoByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductVideoByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVideoByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVideoByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductVideoByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductVideoByIdServer<
  TData = Awaited<ReturnType<typeof getProductVideoByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductVideoByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVideoByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductVideoByIdServer<
  TData = Awaited<ReturnType<typeof getProductVideoByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductVideoByIdServerParams,
  operationName = 'getProductVideoById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVideoByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductVideoByIdServerQueryOptions(productId, params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductManualByIdServer = (
  productId: number,
  params: GetProductManualByIdServerParams,
  operationName = 'getProductManualById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ProductManual>(
    { url: `/cache/productmanual/${productId}`, method: 'GET', params, signal },
    { operationName: 'getProductManualById', ...options }
  );
};

export const useGetProductManualByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductManualByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductManualByIdServerParams,
  operationName = 'getProductManualById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductManualByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productId, params, operationName },
    { url: `/cache/productmanual/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductManualByIdServer>>> = ({ signal }) =>
    getProductManualByIdServer(productId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductManualByIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductManualByIdServerQueryResult = NonNullable<Awaited<ReturnType<typeof getProductManualByIdServer>>>;
export type GetProductManualByIdServerQueryError = ErrorType<unknown>;

export function useGetProductManualByIdServer<
  TData = Awaited<ReturnType<typeof getProductManualByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductManualByIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductManualByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductManualByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductManualByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductManualByIdServer<
  TData = Awaited<ReturnType<typeof getProductManualByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductManualByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductManualByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductManualByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductManualByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductManualByIdServer<
  TData = Awaited<ReturnType<typeof getProductManualByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductManualByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductManualByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductManualByIdServer<
  TData = Awaited<ReturnType<typeof getProductManualByIdServer>>,
  TError = ErrorType<unknown>,
>(
  productId: number,
  params: GetProductManualByIdServerParams,
  operationName = 'getProductManualById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductManualByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductManualByIdServerQueryOptions(productId, params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLinkedProductsByIdServer = (
  market: string,
  mainWebShopId: number,
  productId: number,
  fictiveWebShopId: number,
  productColourId: number,
  params: GetLinkedProductsByIdServerParams,
  operationName = 'getLinkedProductsById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<ProductColourLinkFlatDTO>>(
    {
      url: `/cache/productcolour/links/${market}/${mainWebShopId}/${productId}/${fictiveWebShopId}/${productColourId}`,
      method: 'GET',
      params,
      signal,
    },
    { operationName: 'getLinkedProductsById', ...options }
  );
};

export const useGetLinkedProductsByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getLinkedProductsByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  fictiveWebShopId: number,
  productColourId: number,
  params: GetLinkedProductsByIdServerParams,
  operationName = 'getLinkedProductsById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedProductsByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, productId, fictiveWebShopId, productColourId, params, operationName },
    {
      url: `/cache/productcolour/links/${market}/${mainWebShopId}/${productId}/${fictiveWebShopId}/${productColourId}`,
      queryOptions,
    }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedProductsByIdServer>>> = ({ signal }) =>
    getLinkedProductsByIdServer(
      market,
      mainWebShopId,
      productId,
      fictiveWebShopId,
      productColourId,
      params,
      operationName,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(market && mainWebShopId && productId && fictiveWebShopId && productColourId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLinkedProductsByIdServer>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetLinkedProductsByIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLinkedProductsByIdServer>>
>;
export type GetLinkedProductsByIdServerQueryError = ErrorType<unknown>;

export function useGetLinkedProductsByIdServer<
  TData = Awaited<ReturnType<typeof getLinkedProductsByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  fictiveWebShopId: number,
  productColourId: number,
  params: GetLinkedProductsByIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedProductsByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedProductsByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getLinkedProductsByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLinkedProductsByIdServer<
  TData = Awaited<ReturnType<typeof getLinkedProductsByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  fictiveWebShopId: number,
  productColourId: number,
  params: GetLinkedProductsByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedProductsByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedProductsByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getLinkedProductsByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLinkedProductsByIdServer<
  TData = Awaited<ReturnType<typeof getLinkedProductsByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  fictiveWebShopId: number,
  productColourId: number,
  params: GetLinkedProductsByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedProductsByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLinkedProductsByIdServer<
  TData = Awaited<ReturnType<typeof getLinkedProductsByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  fictiveWebShopId: number,
  productColourId: number,
  params: GetLinkedProductsByIdServerParams,
  operationName = 'getLinkedProductsById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedProductsByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetLinkedProductsByIdServerQueryOptions(
    market,
    mainWebShopId,
    productId,
    fictiveWebShopId,
    productColourId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductTechnicalCategoriesByIdServer = (
  market: string,
  mainWebShopId: number,
  productId: number,
  colourId: number,
  params?: GetProductTechnicalCategoriesByIdServerParams,
  operationName = 'getProductTechnicalCategoriesById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<TechnicalCategory>>(
    {
      url: `/cache/product/technical/features/colours/categories/${market}/${mainWebShopId}/${productId}/${colourId}`,
      method: 'GET',
      params,
      signal,
    },
    { operationName: 'getProductTechnicalCategoriesById', ...options }
  );
};

export const useGetProductTechnicalCategoriesByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  colourId: number,
  params?: GetProductTechnicalCategoriesByIdServerParams,
  operationName = 'getProductTechnicalCategoriesById',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, productId, colourId, params, operationName },
    {
      url: `/cache/product/technical/features/colours/categories/${market}/${mainWebShopId}/${productId}/${colourId}`,
      queryOptions,
    }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>> = ({ signal }) =>
    getProductTechnicalCategoriesByIdServer(
      market,
      mainWebShopId,
      productId,
      colourId,
      params,
      operationName,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(market && mainWebShopId && productId && colourId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetProductTechnicalCategoriesByIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>
>;
export type GetProductTechnicalCategoriesByIdServerQueryError = ErrorType<unknown>;

export function useGetProductTechnicalCategoriesByIdServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  colourId: number,
  params: undefined | GetProductTechnicalCategoriesByIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductTechnicalCategoriesByIdServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  colourId: number,
  params?: GetProductTechnicalCategoriesByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductTechnicalCategoriesByIdServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  colourId: number,
  params?: GetProductTechnicalCategoriesByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductTechnicalCategoriesByIdServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  colourId: number,
  params?: GetProductTechnicalCategoriesByIdServerParams,
  operationName = 'getProductTechnicalCategoriesById',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalCategoriesByIdServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductTechnicalCategoriesByIdServerQueryOptions(
    market,
    mainWebShopId,
    productId,
    colourId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductPlacementCopyByIdServer = (
  mainWebShop: string,
  fictionalShopId: number,
  productId: number,
  params: GetProductPlacementCopyByIdServerParams,
  operationName = 'getProductPlacementCopyById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ProductPlacementCopyResource>(
    { url: `/cache/product/ppc/${mainWebShop}/${fictionalShopId}/${productId}`, method: 'GET', params, signal },
    { operationName: 'getProductPlacementCopyById', ...options }
  );
};

export const useGetProductPlacementCopyByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  fictionalShopId: number,
  productId: number,
  params: GetProductPlacementCopyByIdServerParams,
  operationName = 'getProductPlacementCopyById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebShop, fictionalShopId, productId, params, operationName },
    { url: `/cache/product/ppc/${mainWebShop}/${fictionalShopId}/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>> = ({ signal }) =>
    getProductPlacementCopyByIdServer(
      mainWebShop,
      fictionalShopId,
      productId,
      params,
      operationName,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(mainWebShop && fictionalShopId && productId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetProductPlacementCopyByIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>
>;
export type GetProductPlacementCopyByIdServerQueryError = ErrorType<unknown>;

export function useGetProductPlacementCopyByIdServer<
  TData = Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  fictionalShopId: number,
  productId: number,
  params: GetProductPlacementCopyByIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductPlacementCopyByIdServer<
  TData = Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  fictionalShopId: number,
  productId: number,
  params: GetProductPlacementCopyByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductPlacementCopyByIdServer<
  TData = Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  fictionalShopId: number,
  productId: number,
  params: GetProductPlacementCopyByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductPlacementCopyByIdServer<
  TData = Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  fictionalShopId: number,
  productId: number,
  params: GetProductPlacementCopyByIdServerParams,
  operationName = 'getProductPlacementCopyById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductPlacementCopyByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductPlacementCopyByIdServerQueryOptions(
    mainWebShop,
    fictionalShopId,
    productId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getVoucherMinMaxAmountServer = (
  params: GetVoucherMinMaxAmountServerParams,
  operationName = 'getVoucherMinMaxAmount',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PriceRange>(
    { url: `/cache/product/minmax`, method: 'GET', params, signal },
    { operationName: 'getVoucherMinMaxAmount', ...options }
  );
};

export const useGetVoucherMinMaxAmountServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherMinMaxAmountServerParams,
  operationName = 'getVoucherMinMaxAmount',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/cache/product/minmax`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>> = ({ signal }) =>
    getVoucherMinMaxAmountServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVoucherMinMaxAmountServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>
>;
export type GetVoucherMinMaxAmountServerQueryError = ErrorType<unknown>;

export function useGetVoucherMinMaxAmountServer<
  TData = Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherMinMaxAmountServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
          TError,
          Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetVoucherMinMaxAmountServer<
  TData = Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherMinMaxAmountServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
          TError,
          Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetVoucherMinMaxAmountServer<
  TData = Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherMinMaxAmountServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetVoucherMinMaxAmountServer<
  TData = Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetVoucherMinMaxAmountServerParams,
  operationName = 'getVoucherMinMaxAmount',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucherMinMaxAmountServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetVoucherMinMaxAmountServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find features by language (and feature ids), flattened by filtering out feature types that represent categories or are used for grouping features
 */
export const getProductTechnicalFeaturesFlattenedServer = (
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductTechnicalFeaturesFlattenedServerParams,
  operationName = 'getProductTechnicalFeaturesFlattened',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ProductWithFlattenedFeatures>(
    { url: `/cache/product/features/${market}/${mainWebShopId}/${productId}/flattened`, method: 'GET', params, signal },
    { operationName: 'getProductTechnicalFeaturesFlattened', ...options }
  );
};

export const useGetProductTechnicalFeaturesFlattenedServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductTechnicalFeaturesFlattenedServerParams,
  operationName = 'getProductTechnicalFeaturesFlattened',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, mainWebShopId, productId, params, operationName },
    { url: `/cache/product/features/${market}/${mainWebShopId}/${productId}/flattened`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>> = ({ signal }) =>
    getProductTechnicalFeaturesFlattenedServer(
      market,
      mainWebShopId,
      productId,
      params,
      operationName,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, enabled: !!(market && mainWebShopId && productId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductTechnicalFeaturesFlattenedServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>
>;
export type GetProductTechnicalFeaturesFlattenedServerQueryError = ErrorType<unknown>;

export function useGetProductTechnicalFeaturesFlattenedServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params: undefined | GetProductTechnicalFeaturesFlattenedServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
          TError,
          Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductTechnicalFeaturesFlattenedServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductTechnicalFeaturesFlattenedServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
          TError,
          Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductTechnicalFeaturesFlattenedServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductTechnicalFeaturesFlattenedServerParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find features by language (and feature ids), flattened by filtering out feature types that represent categories or are used for grouping features
 */

export function useGetProductTechnicalFeaturesFlattenedServer<
  TData = Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  mainWebShopId: number,
  productId: number,
  params?: GetProductTechnicalFeaturesFlattenedServerParams,
  operationName = 'getProductTechnicalFeaturesFlattened',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductTechnicalFeaturesFlattenedServer>>, TError, TData>
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductTechnicalFeaturesFlattenedServerQueryOptions(
    market,
    mainWebShopId,
    productId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getProductAvailabilityByIdServer = (
  mainWebShop: string,
  productId: number,
  operationName = 'getProductAvailabilityById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PdpProductAvailabilityDTO>(
    { url: `/cache/product/availability/pdp/${mainWebShop}/${productId}`, method: 'GET', signal },
    { operationName: 'getProductAvailabilityById', ...options }
  );
};

export const useGetProductAvailabilityByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  productId: number,
  operationName = 'getProductAvailabilityById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebShop, productId, operationName },
    { url: `/cache/product/availability/pdp/${mainWebShop}/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>> = ({ signal }) =>
    getProductAvailabilityByIdServer(mainWebShop, productId, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebShop && productId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductAvailabilityByIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>
>;
export type GetProductAvailabilityByIdServerQueryError = ErrorType<unknown>;

export function useGetProductAvailabilityByIdServer<
  TData = Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  productId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductAvailabilityByIdServer<
  TData = Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  productId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductAvailabilityByIdServer<
  TData = Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  productId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProductAvailabilityByIdServer<
  TData = Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>,
  TError = ErrorType<unknown>,
>(
  mainWebShop: string,
  productId: number,
  operationName = 'getProductAvailabilityById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAvailabilityByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductAvailabilityByIdServerQueryOptions(mainWebShop, productId, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCategoryByIdServer = (
  market: string,
  categoryId: number,
  mainWebShopId: number,
  operationName = 'getCategoryById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Category>(
    { url: `/cache/category/${market}/${categoryId}/${mainWebShopId}`, method: 'GET', signal },
    { operationName: 'getCategoryById', ...options }
  );
};

export const useGetCategoryByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getCategoryByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  categoryId: number,
  mainWebShopId: number,
  operationName = 'getCategoryById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, categoryId, mainWebShopId, operationName },
    { url: `/cache/category/${market}/${categoryId}/${mainWebShopId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryByIdServer>>> = ({ signal }) =>
    getCategoryByIdServer(market, categoryId, mainWebShopId, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(market && categoryId && mainWebShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCategoryByIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryByIdServerQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryByIdServer>>>;
export type GetCategoryByIdServerQueryError = ErrorType<unknown>;

export function useGetCategoryByIdServer<
  TData = Awaited<ReturnType<typeof getCategoryByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  categoryId: number,
  mainWebShopId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getCategoryByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryByIdServer<
  TData = Awaited<ReturnType<typeof getCategoryByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  categoryId: number,
  mainWebShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getCategoryByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCategoryByIdServer<
  TData = Awaited<ReturnType<typeof getCategoryByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  categoryId: number,
  mainWebShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetCategoryByIdServer<
  TData = Awaited<ReturnType<typeof getCategoryByIdServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  categoryId: number,
  mainWebShopId: number,
  operationName = 'getCategoryById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetCategoryByIdServerQueryOptions(market, categoryId, mainWebShopId, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
